import React from "react";
import { Box, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
// import PageHeading from "../components/layouts/PageHeading";
import ProgressBarITE from "./nav/ProgressBarITE";
// import ClientEconomies from "../components/forms/ClientEconomies";
import MultiStepForm4ITE from "../../components/formsITE/MultiStepForm4ITE";

const formSections = [
  "Renseignements du client",
  "Bilan Énergétique",
  "Économies Énergétique",
];

const PartFourITE = () => {
  const navigate = useNavigate();
  const currentSection = 2;

  const handleFormSubmit = () => {
    navigate("/");
  };

  return (
    <Box width="full">
      <Box position="sticky" h={"140px"} top={0} bg="white" zIndex={1}>
        {" "}
        <ProgressBarITE sections={formSections} currentSection={currentSection} />
      </Box>
      {/* <ClientEconomies onSubmit={handleFormSubmit} />
       */}
      <MultiStepForm4ITE onSubmit={handleFormSubmit} />
    </Box>
  );
};

export default PartFourITE;
